import { api } from '@services/api'
import {
  FreeMarketLeadCreateDto,
  FreeMarketLeadCreatePayload,
  FreeMarketLeadUpdateDto,
  FreeMarketLeadUpdatePayload
} from './types'

const create = async (payload: FreeMarketLeadCreatePayload) =>
  api.post<FreeMarketLeadCreateDto>('/free_market_leads', payload)

const update = async (free_market_lead: FreeMarketLeadUpdatePayload) =>
  api.put<FreeMarketLeadUpdateDto>(
    `/free_market_leads/${free_market_lead.id}`,
    free_market_lead
  )

const upload = async (
  file: any,
  onProgress?: (percentage: number) => void,
  onSizeLoading?: (size: number) => void
) =>
  api.post('/upload-image', file, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: event => {
      const { loaded, total } = event
      const percent = Math.floor((loaded * 100) / total)

      onProgress(percent)
      onSizeLoading(loaded)
    }
  })

export const FreeMarketLeadsApi = {
  create,
  update,
  upload
}
